<template>
  <SideMenuBase :menuGroups="menuGroups" />
</template>

<script setup>
import SideMenuBase from '@/components/layout/SideMenuBase.vue'

const menuGroups = [
  {
    title: 'Management',
    items: [
      { label: 'Schedule', path: '/operations/schedule' },
      { label: 'Project Pipeline', path: '/operations/project-pipeline' },
      { label: 'Drivers', path: '/operations/driver-assignment', requiredPermission: 'operations.driver_assignment.access' },
      { label: 'Permits', path: '/operations/permits', requiredPermission: 'operations.permits.access' }
    ]
  },
  {
    title: 'Analytics',
    items: [
      { label: 'First Arrival', path: '/operations/first-arrival-analysis', requiredPermission: 'operations.first_arrival.access' },
      { label: 'Company Costing', path: '/operations/company-costing', requiredPermission: 'operations.company_costing.access' },
      { label: 'BU Costing', path: '/operations/business-unit-costing', requiredPermission: 'operations.business_unit_costing.access' },
      { label: 'Project Costing', path: '/operations/project-costing', requiredPermission: 'operations.project_costing.access' },
      { label: 'Job Costing', path: '/operations/job-costing', requiredPermission: 'operations.job_costing.access' },
    ]
  },
  {
    title: 'Resources',
    items: [
      { label: 'EQPT to Register', path: '/operations/equipment-to-register', requiredPermission: 'operations.warranty_registration.access' },
      { label: 'Pricebook Search', path: '/operations/pricebook-search' }
    ]
  }
]
</script>
